import React from 'react';
import * as FiIcons from 'react-icons/fi';
import useAppStore from '../../store';

function RoutingRuleRow({ rule, onToggle, onRemove }) {
  const agents = useAppStore((state) => state.agents);
  const channels = useAppStore((state) => state.channels);
  const agent = agents.find((candidate) => candidate.id === rule.agentId);
  const channel = channels.find((candidate) => candidate.type === rule.channelType);
  const channelLabel = channel?.name ?? rule.channelType;

  return (
    <li className={`rule-row ${rule.enabled ? '' : 'rule-row--disabled'}`}>
      <label className="rule-row__switch">
        <input
          checked={rule.enabled}
          onChange={() => onToggle(rule.id)}
          type="checkbox"
        />
        <span aria-hidden="true" />
      </label>

      <div className="rule-row__statement">
        <strong>{agent?.name ?? `Agent ${rule.agentId}`}</strong>
        <FiIcons.FiArrowRight />
        <em>{rule.event.replace(/_/g, ' ')}</em>
        <FiIcons.FiArrowRight />
        <span className="rule-row__channel">{channelLabel}</span>
        <small>→ {rule.target}</small>
      </div>

      <button
        aria-label={`Delete rule for ${agent?.name ?? rule.agentId}`}
        className="rule-row__delete"
        onClick={() => onRemove(rule.id)}
        type="button"
      >
        <FiIcons.FiTrash2 />
      </button>
    </li>
  );
}

function RoutingRulesTable({ rules }) {
  const updateRoutingRule = useAppStore((state) => state.updateRoutingRule);
  const removeRoutingRule = useAppStore((state) => state.removeRoutingRule);

  if (rules.length === 0) {
    return (
      <div className="rules-empty">
        <FiIcons.FiFilter />
        <p>No routing rules yet.</p>
        <span>Compose one with “New rule” to route agent events to a channel.</span>
      </div>
    );
  }

  return (
    <ul className="rules-list">
      {rules.map((rule) => (
        <RoutingRuleRow
          key={rule.id}
          onRemove={removeRoutingRule}
          onToggle={updateRoutingRule}
          rule={rule}
        />
      ))}
    </ul>
  );
}

export default RoutingRulesTable;
